<template>
  <vip-user></vip-user>
</template>

<script>
import VipUser from "../card/vip/record"
export default {
  data(){
    return{
    }
  },
  components: {
    VipUser
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  padding: 10px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content{
    background: #fff;
    height: 100%;
  }
}
</style>